import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

// Pages
import Home from "./pages/Home";
import Products from "./pages/Products";
import TravelAssistance from "./pages/TravelAssistance";
import AutomotiveAssistance from "./pages/AutomotiveAssistance";
import GadgetProtection from "./pages/GadgetProtection";

import HomeAssistance from "./pages/HomeAssistance";
import CyberSecurity from "./pages/CyberSecurity";

import AboutUs from "./pages/AboutUs";
import Career from "./pages/Career";
import Blogs from "./pages/Blogs";
import BecomePartner from "./pages/BecomePartner";

import ContactUs from "./pages/ContactUs";
import Header from "./layout/Header";
import IncomeProtection from "./pages/IncomeProtection";
import Footer from "./layout/Footer";
import MobileProtection from "./pages/MobileProtection";
import HomeAppliances from "./pages/HomeAppliances";
import JobDetails from "./components/Career/JobDetails";
import BackgroundBanner from "./layout/BackgroundBanner";
// Admin Dashboard Pages
import DashboardHome from "./pages/AdminDashboard/DashboardHome";
import Users from "./pages/AdminDashboard/Users";
import Settings from "./pages/AdminDashboard/Settings";
import RequireAuth from "./pages/AdminDashboard/RequireAuth";
import Login from "./pages/AdminDashboard/Login";
import Jobs from "./pages/AdminDashboard/Jobs";
import AdminBlogs from "./pages/AdminDashboard/Blogs";
import BlogDetails from "./pages/BlogsDetails";
import { ToastContainer } from "react-toastify";
import PageNotFound from "./pages/PageNotFound";

const App = () => {
  return (
    <Router>
      <ToastContainer />
      {/* {(() => {
        const isAdminRoute = window.location.pathname.startsWith("/admin");
        return !isAdminRoute ? <Header /> : null;
      })()} */}
      {/* <BackgroundBanner /> */}
      <Routes>
        {/* ...existing routes... */}
        <Route path="/" element={<Home />} />
        <Route path="*" element={<PageNotFound />} />
        <Route path="/products" element={<Products />} />
        <Route path="/travel-assistance" element={<TravelAssistance />} />
        <Route
          path="/automotive-assistance"
          element={<AutomotiveAssistance />}
        />
        <Route path="/gadget-protection" element={<GadgetProtection />} />
        <Route path="/home-assistance" element={<HomeAssistance />} />
        <Route path="/income-protect" element={<IncomeProtection />} />
        <Route path="/cyber-security" element={<CyberSecurity />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/career" element={<Career />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs-details" element={<BlogDetails />} />
        <Route path="/become-partner" element={<BecomePartner />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/mobile-protection" element={<MobileProtection />} />
        <Route path="/home-appliances" element={<HomeAppliances />} />
        <Route path="/career-job-role" element={<JobDetails />} />

        {/* Admin Dashboard */}
        <Route
          path="/admin"
          element={
            <RequireAuth>
              <DashboardHome />
            </RequireAuth>
          }
        />
        <Route
          path="/admin/blogs"
          element={
            <RequireAuth>
              <AdminBlogs />
            </RequireAuth>
          }
        />
        <Route
          path="/admin/jobs"
          element={
            <RequireAuth>
              <Jobs />
            </RequireAuth>
          }
        />
        <Route path="/login" element={<Login />} />
        {/* Catch-all route: redirect to home */}
        {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
      </Routes>
      {(() => {
        const isAdminRoute = window.location.pathname.startsWith("/admin");
        return !isAdminRoute ? <Footer /> : null;
      })()}
    </Router>
  );
};

export default App;
